module.exports = __webpack_public_path__ + "img/QuanspireLogoWhite.cc6a88a6.svg";